import React from 'react';

import PartnerHero from '../components/PartnerHero/PartnerHero';
import PartnerBenefits from '../components/PartnerBenefits/PartnerBenefits';
import PartnerProcess from '../components/PartnerProcess/PartnerProcess';
import ContactBanner from '../components/ContactBanner/ContactBanner';

const PartnerPage = () => {
  return (
    <>
      <PartnerHero />
      <PartnerBenefits />
      <PartnerProcess />
    </>
  );
};

export default PartnerPage;
